import { isNumberString } from "@corca/core";

import { isInsideCasesGroup } from "@/components/expression/utils/groups";
import { PlainTextNodeModel } from "@/models/nodes/PlainTextNodeModel";
import { isUnitChild } from "@/models/nodes/utils";
import { isLabelOrSubscript } from "@/models/utils/semanticChecks";

import { symbolLookupFor } from "./utils/symbolLookup";

import type {
  SuggestionProvider,
  Suggestion,
  SuggestionItem,
} from "@/components/suggestions/types";

export const plainTextSuggestionsProvider: SuggestionProvider = {
  type: "plainText",
  search: (str, doc) => {
    const options: Suggestion[] = [];
    const { node } = doc.cursor;

    if (!isLabelOrSubscript(node?.parent) && !isInsideCasesGroup(node) && !isUnitChild(node)) {
      return [options];
    }

    if (!isNumberString(str) && str.length > 0) {
      let suggestionItem: SuggestionItem | null = null;
      const symbolKey = symbolLookupFor(doc).byGlyph(str)?.key;

      if (symbolKey) {
        suggestionItem = {
          type: "symbol",
          symbol: str,
          intlName: "plainText",
          props: {
            key: symbolKey,
          },
          category: "New",
          isNewNode: true,
        } as SuggestionItem<"symbol">;
      } else {
        const containsLetters = /\p{L}/u.test(str);

        if (containsLetters) {
          suggestionItem = {
            type: "plainText",
            symbol: str,
            intlName: "plainText",
            category: "New",
            isNewNode: true,
          };
        }
      }

      if (suggestionItem) {
        const hasNonLabels = node?.nodes.some((n) => !n.is(PlainTextNodeModel));
        const suggestion: Suggestion = {
          type: "single",
          item: suggestionItem,
          priority: hasNonLabels ? 0 : 1.6,
          popupGroup: "plainText",
        };

        options.push(suggestion);
      }
    }

    return [options];
  },
};
